import { Alert } from "@hightouch/htui";
import type { InsightsFailure } from "src/pages/ad-studio/insights/performance/types";
import { failureMessage } from "src/pages/ad-studio/insights/performance/utils/query-result";

type FailureAlertProps = { failure: InsightsFailure; title?: string };

export const FailureAlert = ({
  failure,
  title = "Failed to load performance data",
}: FailureAlertProps) => (
  <Alert type="error" title={title} message={failureMessage(failure)} my={4} />
);
